module.exports = __webpack_public_path__ + "img/le_pellerin.5805876b.jpg";